import {lazy} from 'react';
import GenericFallbackSuspense from '../../ui/GenericFallback/GenericFallbackSuspense';

const AddressLookupField = lazy(() => (
  import('./AddressLookupField/AddressLookupField'/* webpackChunkName: 'AddressLookupField' */)
));

export default function AddressLookupLazyLoader(props) {
  return (
    <GenericFallbackSuspense>
      <AddressLookupField {...props} />
    </GenericFallbackSuspense>
  );
}
